import script from "./Title.vue?vue&type=script&lang=ts&setup=true"
export * from "./Title.vue?vue&type=script&lang=ts&setup=true"

import "./Title.vue?vue&type=style&index=0&id=668d0766&lang=less"

const __exports__ = script;

export default __exports__